import React, { useMemo, useState } from "react";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";

// Datos generados desde tu Excel (62 items)
const INTEGRATIONS = [
  // --- Bancos (Panamá) ---
  { name: "Global Bank", service: "Banca", country: "Panamá", url: "https://www.globalbank.com.pa", logo: "https://www.google.com/s2/favicons?domain=www.globalbank.com.pa&sz=64", slug: "global-bank", desc: "Integra tu POS con Global Bank para depósitos más rápidos, conciliaciones automáticas y una gestión bancaria ágil en Panamá." },
  { name: "Credicorp Bank", service: "Banca", country: "Panamá", url: "https://www.credicorpbank.com", logo: "https://www.google.com/s2/favicons?domain=www.credicorpbank.com&sz=64", slug: "credicorp-bank", desc: "Procesa cobros y liquida a tus cuentas Credicorp con controles de conciliación y reportes listos para contabilidad." },
  // { name: "Banco general", service: "Banca", country: "Panamá", url: "https://www.bgeneral.com", logo: "https://www.google.com/s2/favicons?domain=www.bgeneral.com&sz=64", slug: "banco-general", desc: "Conecta cuentas de Banco General para automatizar depósitos, validar abonos y simplificar cierres diarios." },
  { name: "Caja de Ahorros", service: "Banca", country: "Panamá", url: "https://www.cajadeahorros.com.pa", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSl9T9n5dxni3VFwbs5a5imALt0s-llRf1jKQ&s", slug: "caja-de-ahorros", desc: "Integra tu POS con Caja de Ahorros para depósitos ágiles, conciliación eficiente y una experiencia bancaria moderna en Panamá." },
  { name: "Yappy Bussines", service: "Banca", country: "Panamá", url: "https://www.yappy.com.pa", logo: "https://www.google.com/s2/favicons?domain=www.yappy.com.pa&sz=64", slug: "yappy-bussines", desc: "Cobros instantáneos por Yappy Business con confirmación inmediata y conciliación en tu POS." },
  { name: "Bac Credomatic", service: "Banca", country: "Panamá", url: "https://www.baccredomatic.com", logo: "https://www.google.com/s2/favicons?domain=www.baccredomatic.com&sz=64", slug: "bac-credomatic", desc: "Pagos y servicios de BAC integrados a tu operación: liquidaciones, conciliación y reportes en tiempo real." },

  // --- Contabilidad ---
  { name: "Xero", service: "Contabilidad", country: "Global", url: "https://www.xero.com", logo: "https://www.google.com/s2/favicons?domain=www.xero.com&sz=64", slug: "xero", desc: "Sincroniza ventas, impuestos y catálogos desde tu POS a Xero para cierres contables precisos." },
  { name: "Sage", service: "Contabilidad", country: "Global", url: "https://www.sage.com/es-es/", logo: "https://www.google.com/s2/favicons?domain=www.sage.com&sz=64", slug: "sage", desc: "Exporta facturas, pagos y clientes a Sage con mapeo de cuentas y centros de costo." },
  { name: "Boton", service: "Contabilidad", country: "Panamá", url: "https://try.botonapp.com/", logo: "https://img.invupos.com/webinvu/Integrationsv1/boton-200h_m2lgli.png", slug: "hero", desc: "Toma Decisiones de Negocio con Confianza. Con Datos en Tiempo Real." },
  { name: "Sage 50", service: "Contabilidad", country: "Global", url: "https://www.sage.com/es-es/productos/sage-50cloud/", logo: "https://www.google.com/s2/favicons?domain=www.sage.com&sz=64", slug: "sage-50", desc: "Concilia ventas e inventario con Sage 50 para reportes confiables y cierres rápidos." },
  { name: "Davo", service: "Contabilidad", country: "Global", url: "https://www.davosalestax.com", logo: "https://www.google.com/s2/favicons?domain=www.davosalestax.com&sz=64", slug: "davo", desc: "Automatiza la estimación, retención y pago de impuestos sobre ventas para evitar multas." },
  { name: "Quickbooks", service: "Contabilidad", country: "Global", url: "https://quickbooks.intuit.com", logo: "https://www.google.com/s2/favicons?domain=quickbooks.intuit.com&sz=64", slug: "quickbooks", desc: "Exporta transacciones y conciliaciones a QuickBooks con plan de cuentas y centros de costo alineados." },

  // --- ERP ---
  { name: "SAP B1", service: "ERP", country: "Global", url: "https://www.sap.com", logo: "https://www.google.com/s2/favicons?domain=www.sap.com&sz=64", slug: "sap-b1", desc: "Integra SAP Business One con tu POS para un inventario, compras y finanzas centralizados." },
  { name: "Oracle Netsuite", service: "ERP", country: "Global", url: "https://www.netsuite.com/portal/home.shtml", logo: "https://www.google.com/s2/favicons?domain=www.netsuite.com&sz=64", slug: "oracle-netsuite", desc: "Sincroniza órdenes, pagos, clientes y stock con NetSuite para operación omnicanal." },
  { name: "Zoho", service: "ERP", country: "Global", url: "https://www.zoho.com", logo: "https://www.google.com/s2/favicons?domain=www.zoho.com&sz=64", slug: "zoho", desc: "Conecta ventas y CRM con módulos de inventario, facturación y analítica en Zoho." },
  { name: "ASAP", service: "Delivery", country: "Panamá", url: "https://asap507.com", logo: "https://www.google.com/s2/favicons?domain=asap507.com&sz=64", slug: "asap", desc: "Logística y última milla en Panamá con integración directa a tus pedidos del POS." },

  // --- Delivery ---
  { name: "UberEats", service: "Delivery", country: "Global", url: "https://www.ubereats.com", logo: "https://www.google.com/s2/favicons?domain=www.ubereats.com&sz=64", slug: "ubereats", desc: "Publica menús y recibe pedidos de UberEats directamente en caja, con estados y tiempos de preparación." },
  { name: "Rappi", service: "Delivery", country: "Global", url: "https://www.rappi.com.co", logo: "https://www.google.com/s2/favicons?domain=www.rappi.com.co&sz=64", slug: "rappi", desc: "Sincroniza catálogo y precios con Rappi; recibe órdenes y actualiza inventario en tu POS." },
  { name: "Deliverect", service: "Delivery Hub", country: "Global", url: "https://www.deliverect.com/es", logo: "https://www.google.com/s2/favicons?domain=www.deliverect.com&sz=64", slug: "deliverect", desc: "Unifica UberEats, Rappi y más en un solo flujo: menús centralizados, tickets a cocina y reporte unificado." },
  { name: "Mr.pedidos", service: "Delivery", country: "Panamá", url: "https://www.instagram.com/mrpedidos507/", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQ3_suHvlBuKyqO4RxK0Oxj8Af0EcwmV8cqg&s", slug: "mr-pedidos", desc: "Red de repartidores para entregas locales; integra recepción de pedidos y seguimiento desde tu POS." },

  // --- E-commerce / Hotelería / Inventarios / Lealtad / Reservas ---
  { name: "Staples Connect", service: "E-commerce", country: "Global", url: "https://www.staples.com", logo: "https://www.google.com/s2/favicons?domain=www.staples.com&sz=64", slug: "staples-connect", desc: "Conecta tu catálogo de productos con Staples Connect y habilita flujos de venta B2B y compras en línea." },
  { name: "Shogo", service: "E-commerce", country: "Global", url: "http://shogo.io/", logo: "https://www.google.com/s2/favicons?domain=shogo.io&sz=64", slug: "shogo", desc: "Integra ventas del POS con plataformas de contabilidad y e-commerce mediante Shogo, automatizando conciliaciones." },
  { name: "WooCommerce", service: "E-commerce", country: "Global", url: "https://woocommerce.com/es/", logo: "https://www.google.com/s2/favicons?domain=woocommerce.com&sz=64", slug: "woocommerce", desc: "Sincroniza productos, precios, inventario y pedidos de WooCommerce directamente con tu POS." },
  { name: "Shopify", service: "E-commerce", country: "Global", url: "https://www.shopify.com/es", logo: "https://www.google.com/s2/favicons?domain=www.shopify.com&sz=64", slug: "shopify", desc: "Conecta Shopify con tu operación para mantener catálogo, ventas y stock alineados en tiempo real." },
  { name: "Cloudbeds", service: "Hotelería", country: "Global", url: "https://www.cloudbeds.com", logo: "https://www.google.com/s2/favicons?domain=www.cloudbeds.com&sz=64", slug: "cloudbeds", desc: "Centraliza PMS, reservas y cargos a habitación integrando consumos del POS a Cloudbeds." },
  { name: "MEWS", service: "Hotelería", country: "Global", url: "https://www.mews.com/es/", logo: "https://www.google.com/s2/favicons?domain=www.mews.com&sz=64", slug: "mews", desc: "Conecta tu POS al PMS de MEWS para cargos a habitación, auditoría nocturna y control de cuentas de huéspedes." },
  { name: "Marketman", service: "Inventarios", country: "Global", url: "https://es.marketman.com", logo: "https://www.google.com/s2/favicons?domain=es.marketman.com&sz=64", slug: "marketman", desc: "Gestiona inventario, recetas y costos de insumos con integración directa a ventas del POS." },
  { name: "Clau.io", service: "Lealtad", country: "Global", url: "https://clau.io", logo: "https://www.google.com/s2/favicons?domain=clau.io&sz=64", slug: "clau-io", desc: "Lanza programas de lealtad y cupones personalizados; refleja puntos y redenciones en tiempo real en tu POS." },
  { name: "OpenTable", service: "Reservas", country: "Global", url: "https://www.opentable.com", logo: "https://www.google.com/s2/favicons?domain=www.opentable.com&sz=64", slug: "opentable", desc: "Sincroniza reservas y walk-ins de OpenTable con la gestión de mesas y tiempos en tu restaurante." },
  { name: "Rooam", service: "Banca", country: "Global", url: "https://rooam.co", logo: "https://www.google.com/s2/favicons?domain=rooam.co&sz=64", slug: "rooam", desc: "Habilita pagos móviles sin fricción desde Rooam, vinculando cobros y conciliaciones en tu POS." },

  // --- Servicios / ERP locales ---
  { name: "APC Buro", service: "Servicios", country: "Panamá", url: "https://www.apcexperian.com", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjILgr6pjYma1dKUXSrvNAMzm7SOUP-rZ73w&s", slug: "apc-buro", desc: "Verificación de historial y riesgo crediticio integrada a tus flujos de alta y financiamiento." },
  { name: "Magento 2", service: "E-commerce", country: "Global", url: "https://magento.com", logo: "https://connectif.ai/wp-content/uploads/2023/07/Magento.png", slug: "magento-2", desc: "Sincroniza catálogo, precios e inventario entre Magento 2 y tu POS para operación omnicanal." },
  { name: "Flexio", service: "ERP", country: "Panamá", url: "http://www.flexioonline.com/", logo: "https://media.licdn.com/dms/image/v2/C4D0BAQFZMt9UHiFXoQ/company-logo_200_200/company-logo_200_200/0/1631337859715?e=2147483647&v=beta&t=zgEIfWnKqX9zyZ3EBbDiPNnFlDT73JBEB_B_QABkF1M", slug: "flexio", desc: "Integra facturación, CxC y flujo de caja con ventas del POS y reportes en tiempo real." },
  { name: "Interfuerza", service: "ERP", country: "Panamá", url: "https://www.interfuerza.com/planes/", logo: "https://www.google.com/s2/favicons?domain=www.interfuerza.com&sz=64", slug: "interfuerza", desc: "ERP para PyMES: inventario, compras y clientes conectados a tu punto de venta." },

  // --- Pagos / Redes (Colombia / El Salvador) ---
  { name: "Siigo", service: "ERP", country: "Colombia", url: "https://www.siigo.com", logo: "https://www.google.com/s2/favicons?domain=www.siigo.com&sz=64", slug: "siigo-erp-co", desc: "Contabilidad e inventarios enlazados al POS con parametrización fiscal para Colombia." },
  { name: "Siesa", service: "ERP", country: "Colombia", url: "https://www.siesa.com", logo: "https://img.invupos.com/webinvu/Integrationsv1/Screenshot_2025-09-01_at_3.44.02_PM_u5s3dl.png", slug: "siesa-erp-co", desc: "Consolida compras, ventas y existencias; integra documentos y maestros desde el POS." },
  { name: "Bold", service: "Banca", country: "Colombia", url: "https://www.bold.co", logo: "https://www.google.com/s2/favicons?domain=www.bold.co&sz=64", slug: "bold-co", desc: "Acepta tarjetas y pagos electrónicos con conciliación automática y cortes diarios." },
  { name: "Redeban", service: "Banca", country: "Colombia", url: "https://www.redeban.com.co", logo: "https://play-lh.googleusercontent.com/QjikkOguqvTJ3p6f7gvDFFtefFVFMV1KBBwk7zzVShVTTQNcBC7f4qyDOgO6bzjAZ_mL", slug: "rdeban", desc: "Conecta con la red Redeban para procesamiento y liquidación de transacciones." },
  { name: "Crediban", service: "Banca", country: "Colombia", url: "https://www.credibanco.com", logo: "https://www.google.com/s2/favicons?domain=www.credibanco.com&sz=64", slug: "crediban", desc: "Procesamiento de tarjetas vía Credibanco con conciliación de abonos a tu POS." },
  { name: "Davivienda", service: "Banca", country: "El Salvador", url: "https://www.davivienda.com.sv", logo: "https://www.google.com/s2/favicons?domain=www.davivienda.com.sv&sz=64", slug: "davivienda-sv", desc: "Pagos con tarjeta y administración de liquidaciones bancarias para tu operación en El Salvador." },
  { name: "Siigo", service: "Contabilidad", country: "Colombia", url: "https://www.siigo.com", logo: "https://www.google.com/s2/favicons?domain=www.siigo.com&sz=64", slug: "siigo-cont-co", desc: "Envía ventas, impuestos y comprobantes de tu POS a Siigo Contabilidad con estructura fiscal local." },
  // { name: "Rappi", service: "Delivery", country: "Colombia", url: "https://www.rappi.com.co", logo: "https://www.google.com/s2/favicons?domain=www.rappi.com.co&sz=64", slug: "rappi-co", desc: "Sincroniza tu operación en Colombia con Rappi: recibe pedidos en caja y controla inventario automáticamente." },

  // --- México (ERP, Contabilidad, E-commerce, Hotelería, Pagos) ---
  // { name: "Xero", service: "Contabilidad", country: "México", url: "https://www.xero.com", logo: "https://www.google.com/s2/favicons?domain=www.xero.com&sz=64", slug: "xero-mx", desc: "Conecta ventas e impuestos de tus sucursales en México a Xero para cierres contables más ágiles." },
  { name: "Quickbooks", service: "Contabilidad", country: "México", url: "https://quickbooks.intuit.com", logo: "https://www.google.com/s2/favicons?domain=quickbooks.intuit.com&sz=64", slug: "quickbooks-mx", desc: "Integra QuickBooks México con tu POS: genera facturación, conciliaciones y reportes fiscales en tiempo real." },
  { name: "Microsoft Dynamics", service: "ERP", country: "México", url: "https://dynamics.microsoft.com", logo: "https://www.google.com/s2/favicons?domain=dynamics.microsoft.com&sz=64", slug: "microsoft-dynamics-mx", desc: "Sincroniza Dynamics 365 con tu POS para centralizar inventarios, clientes y finanzas en México." },
  { name: "Oracle Netsuite", service: "ERP", country: "México", url: "https://www.netsuite.com/portal/home.shtml", logo: "https://www.google.com/s2/favicons?domain=www.netsuite.com&sz=64", slug: "oracle-netsuite-mx", desc: "Opera Oracle NetSuite en México integrando órdenes, pagos y existencias desde tu POS." },
  { name: "Odoo", service: "ERP", country: "México", url: "https://www.odoo.com", logo: "https://www.google.com/s2/favicons?domain=www.odoo.com&sz=64", slug: "odoo-mx", desc: "Conecta Odoo con tu POS en México para facturación, inventarios y procesos front y back-office." },
  // { name: "Deliverect", service: "Delivery Hub", country: "México", url: "https://www.deliverect.com/es", logo: "https://www.google.com/s2/favicons?domain=www.deliverect.com&sz=64", slug: "deliverect-mx", desc: "Consolida UberEats, Rappi y Didi en México; gestiona menús y pedidos desde un solo flujo centralizado." },
  // { name: "WooCommerce", service: "E-commerce", country: "México", url: "https://woocommerce.com/es/", logo: "https://www.google.com/s2/favicons?domain=woocommerce.com&sz=64", slug: "woocommerce-mx", desc: "Conecta tu WooCommerce en México con tu POS: productos, inventario y pedidos sincronizados en tiempo real." },
  // { name: "Shopify", service: "E-commerce", country: "México", url: "https://www.shopify.com/es", logo: "https://www.google.com/s2/favicons?domain=www.shopify.com&sz=64", slug: "shopify-mx", desc: "Sincroniza Shopify México con tu operación en caja, inventarios y reportes de ventas unificados." },
  // { name: "Cloudbeds", service: "Hotelería", country: "México", url: "https://www.cloudbeds.com", logo: "https://www.google.com/s2/favicons?domain=www.cloudbeds.com&sz=64", slug: "cloudbeds-mx", desc: "Integra cargos a habitación y consumos de restaurantes con Cloudbeds (PMS) en México." },
  // { name: "MEWS", service: "Hotelería", country: "México", url: "https://www.mews.com/es/", logo: "https://www.google.com/s2/favicons?domain=www.mews.com&sz=64", slug: "mews-mx", desc: "Conecta tu POS con MEWS México para cargos a huéspedes, auditoría nocturna y conciliación automática." },
  { name: "Winks", service: "Hotelería", country: "México", url: "https://winkshotel.com.ar", logo: "https://www.google.com/s2/favicons?domain=wink-hotels.com&sz=64", slug: "winks-mx", desc: "Integración hotelera prevista en México; cargos a habitación y sincronización de consumos con POS." },
  // { name: "Marketman", service: "Inventarios", country: "México", url: "https://es.marketman.com", logo: "https://www.google.com/s2/favicons?domain=es.marketman.com&sz=64", slug: "marketman-mx", desc: "Controla costos, recetas y compras en México con inventarios conectados a las ventas del POS." },
  // { name: "OpenTable", service: "Reservas", country: "México", url: "https://www.opentable.com", logo: "https://www.google.com/s2/favicons?domain=www.opentable.com&sz=64", slug: "opentable-mx", desc: "Sincroniza reservas y turnos de OpenTable México con mesas y cuentas en tu restaurante." },
  // { name: "Magento 2", service: "E-commerce", country: "México", url: "https://magento.com", logo: "https://connectif.ai/wp-content/uploads/2023/07/Magento.png", slug: "magento-2-mx", desc: "Conecta Magento 2 México con tu POS: catálogo, stock y pedidos consistentes en todos los canales." },
  { name: "Riservi", service: "Reservas", country: "México", url: "https://www.riservi.com", logo: "https://www.google.com/s2/favicons?domain=www.riservi.com&sz=64", slug: "riservi-mx", desc: "Gestión de reservas y aforo integrada a tu operación en México; confirmación de partner pendiente." },
  { name: "Kushki", service: "Banca", country: "México", url: "https://www.kushki.com", logo: "https://www.google.com/s2/favicons?domain=www.kushki.com&sz=64", slug: "kushki-mx", desc: "Acepta tarjetas y medios locales en México con antifraude y conciliación automática." },
  { name: "Adyen", service: "Banca", country: "México", url: "https://www.adyen.com", logo: "https://www.google.com/s2/favicons?domain=www.adyen.com&sz=64", slug: "adyen-mx", desc: "Pasarela global en México: tarjetas, wallets y métodos de pago locales con alta tasa de aprobación." },
  // { name: "Clau.io", service: "Lealtad", country: "México", url: "https://clau.io", logo: "https://www.google.com/s2/favicons?domain=clau.io&sz=64", slug: "clau-io-mx", desc: "Lealtad y marketing automatizado en México: integra puntos, cupones y campañas al POS." },
  { name: "Picker Express", service: "Delivery", country: "México", url: "https://www.pickerexpress.com", logo: "https://www.google.com/s2/favicons?domain=www.pickerexpress.com&sz=64", slug: "picker-express-mx", desc: "Plataforma de repartidores para última milla en México, integrada con pedidos y caja en tu POS." },
];

// Normalización SOLO para el filtro de servicios
const normalizeService = (s) => {
  if (!s) return s;
  const t = s.trim().toLowerCase();
  if (t.includes("e-commer")) return "E-commerce";
  if (t.includes("delivery")) return "Delivery";
  return s;
};

const uniqueSorted = (arr) =>
  Array.from(new Set(arr.filter(Boolean))).sort((a, b) => a.localeCompare(b));

/* 🔵 NUEVO MODAL PARA MÁS INFORMACIÓN */
function IntegrationModal({ item, onClose }) {
  if (!item) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
    <div className="relative bg-white rounded-2xl p-8 w-full max-w-lg shadow-xl">

      {/* ❌ Botón cerrar arriba a la derecha */}
      <button
  onClick={onClose}
  className="absolute top-4 right-4 h-10 w-10 flex items-center justify-center
             rounded-full bg-gray-200 hover:bg-gray-300 
             text-gray-700 text-xl hover:text-gray-900 
             shadow-sm transition"
  aria-label="Cerrar"
>
  ×
</button>

      <div className="flex items-center gap-4 mb-4">
        <img src={item.logo} alt={item.name} className="h-16 w-16 rounded-xl" />
        <div>
          <h2 className="text-3xl font-bold">{item.name}</h2>
          <p className="text-gray-600">{item.service} — {item.country}</p>
        </div>
      </div>

      <p className="text-gray-700 mt-2 leading-relaxed">{item.desc}</p>

      <div className="mt-6 flex flex-col gap-3">
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          className="w-full text-center bg-blue-600 text-white py-3 rounded-full font-semibold hover:bg-blue-700 transition"
        >
          Página web de la integración
        </a>
      </div>

    </div>
  </div>
  );
}

function IntegrationCard({ item, onOpen }) {
  const helper =
    item.desc ||
    `${item.name} te conecta con ${item.service.toLowerCase()} en ${item.country}.`;

  return (
    <div
      className="group block rounded-[28px] border border-blue-300 bg-white p-6 sm:p-8 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer"
      style={{ boxShadow: "0 4px 16px rgba(2, 110, 255, 0.08)" }}
    >
      <div className="relative rounded-[24px]">
        <div className="mb-6 flex items-center gap-3">
          <img src={item.logo} alt={item.name} className="h-14 w-14 rounded-lg" />
          <div className="leading-none">
            <p className="text-[28px] font-extrabold tracking-tight leading-none">
              {item.name}
            </p>
            <p className="mt-0.5 text-[20px] font-light tracking-tight leading-none">
              {normalizeService(item.service)}
            </p>
          </div>
        </div>

          {/* TAGS */}
          <div className="flex flex-wrap gap-2 mb-3">
          {item.tags?.map((t) => (
            <span
              key={t}
              className="inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium text-gray-700 bg-gray-50"
            >
              {t}
            </span>
          ))}
        </div>


        <h3 className="mt-2 text-xl font-black tracking-tight">
          {item.name.toUpperCase()}
        </h3>

        <p className="mt-3 text-[15px] leading-6 text-gray-700 line-clamp-4">
          {helper}
        </p>

        <div className="mt-6">
          <button
            onClick={() => onOpen(item)}
            className="inline-flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-700 w-full"
          >
            Más información
          </button>
        </div>
      </div>
    </div>
  );
}

const Integrations = ({
  heroImageSrc = "https://img.invupos.com/webinvu/Integrationsv1/INVU_POS_INTEGRATIONS_LANDING_hwkmdm.png",
}) => {
  const [q, setQ] = useState("");
  const [svc, setSvc] = useState("all");
  const [ctry, setCtry] = useState("all");

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useDocumentTitle("INTEGRACIONES | INVU POS");

  const openModal = (item) => {
    setSelected(item);
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelected(null);
    setIsOpen(false);
  };

  const DATA = useMemo(
    () =>
      INTEGRATIONS.map((i, idx) => ({
        ...i,
        id: idx + 1,
        normService: normalizeService(i.service),
        tags: (() => {
          const arr = [];
          const c = (i.country || "").trim();
        
          if (c) arr.push(c);
        
          return arr;
        })(),
      })),
    []
  );

  const SERVICES = useMemo(
    () => ["all", ...uniqueSorted(DATA.map((i) => i.normService))],
    [DATA]
  );

  const COUNTRIES = useMemo(() => {
    const tagList = DATA.flatMap((i) => i.tags || []);
    return ["all", ...uniqueSorted(tagList)];
  }, [DATA]);

  const list = useMemo(() => {
    const query = q.trim().toLowerCase();

    return DATA.filter((i) => {
      const matchesQ =
        !query ||
        (i.name + " " + i.service + " " + i.country)
          .toLowerCase()
          .includes(query);

      const matchesSvc = svc === "all" || i.normService === svc;

      const matchesC =
      ctry === "all"
        ? true
        : ctry === "Global"
        ? i.country === "Global"
        : i.tags?.includes(ctry);

      return matchesQ && matchesSvc && matchesC;
    });
  }, [q, svc, ctry, DATA]);

  
  return (
    <>
      {isOpen && <IntegrationModal item={selected} onClose={closeModal} />}

      <section className="bg-[#f7f8fb] py-16">
        <div className="mx-auto max-w-7xl px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-5xl md:text-[60px] font-extrabold tracking-tight leading-tight">
              Un solo sistema, <span className="text-blue-600">infinitas</span>{" "}
              conexiones
            </h1>
            <p className="mt-6 text-lg md:text-xl text-gray-700 max-w-2xl">
              Con Invu POS puedes conectar con bancos, delivery, contabilidad, ERP
              y más. Este es el listado completo de integraciones disponibles.
            </p>
          </div>
          <div>
            <img src={heroImageSrc} alt="Invu POS UI" className="w-full" />
          </div>
        </div>

        {/* Filtros */}
        <div className="mx-auto max-w-7xl px-6 mt-12 grid md:grid-cols-3 gap-4">
          <select
            value={svc}
            onChange={(e) => setSvc(e.target.value)}
            className="w-full rounded-full border px-4 py-3 text-sm bg-white"
          >
            {SERVICES.map((v) => (
              <option key={v} value={v}>
                {v === "all" ? "Todos los servicios" : v}
              </option>
            ))}
          </select>

          <select
            value={ctry}
            onChange={(e) => setCtry(e.target.value)}
            className="w-full rounded-full border px-4 py-3 text-sm bg-white"
          >
            {COUNTRIES.map((v) => (
              <option key={v} value={v}>
                {v === "all" ? "Todos los países (Global)" : v}
              </option>
            ))}
          </select>

          <div className="relative">
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
            >
              <path
                fill="currentColor"
                d="M15.5 14h-.79l-.28-.27A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14z"
              />
            </svg>
            <input
              type="text"
              placeholder="Buscar por nombre, servicio o país"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="w-full rounded-full border pl-11 pr-4 py-3 text-sm bg-white placeholder:text-gray-400"
            />
          </div>
        </div>

        {/* Grid con todas las integraciones */}
        <div className="mx-auto max-w-7xl px-6 mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((i) => (
            <IntegrationCard key={i.slug} item={i} onOpen={openModal} />
          ))}
        </div>

        <div className="mt-10 text-center text-sm text-gray-500">
          Mostrando {list.length} de {INTEGRATIONS.length} integraciones
        </div>
      </section>
    </>
  );
};

export default Integrations;